/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { ETrackedItemTypes } from "../../../constants/trackedItems"

export interface UsersState {
  /** All Argos users */
  users: User[]

  /** Current user */
  currentUser: string | null

  /** User data loading state */
  isFetchingUsers: boolean
}

export type User = {
  /** User's GMID */
  id: string

  /** User's first name */
  firstName: string

  /** User's last name */
  lastName: string

  /** User's e-mail */
  email: string

  /** User's status */
  userStatus: UserStatus

  /** User's permissions */
  permissions: Permissions

  /** User's login count */
  loginCount: number

  /** User's last login timestamp */
  loginTs: number

  /** User's favorited items */
  tree_favorites: any

  /** User's recently viewed items */
  recently_viewed: any[]
}

export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export type Permissions = {
  /** User is administrator */
  admin: boolean

  /** Date permissions updated */
  date: string

  /** Access by route */
  userArgosRoutePermissions: RoutePermission
}

export type Favorites = {
  /** TODO: Descibe what this does */
  num_nodes: number

  /** TODO: Descibe what this does */
  max_node_id: number

  /** TODO: Descibe what this does */
  tree_data: FavoritesTreeData
}

export type FavoritesTreeData = {
  /** TODO: Descibe what this does */
  nodeId: string

  /** TODO: Descibe what this does */
  label?: string

  /** TODO: Descibe what this does */
  data: FavoritesTreeDataData

  /** TODO: Descibe what this does */
  children?: FavoritesTreeData[]
}

export type FavoritesTreeDataData = {
  /** Item's database ID */
  trackedItemUid?: string

  /** Item's database partition key */
  partitionKey?: string

  /** Item's database container key */
  trackedItemType?: ETrackedItemTypes
}

export type RecentlyViewed = {
  /** Item's database ID */
  trackedItemUid: string

  /** Item's database partition key */
  partitionKey: string

  /** Item's database container key */
  trackedItemType: ETrackedItemTypes

  /** Item's last viewed timestamp */
  time: number
}

export type RoutePermission = {
  /** The access level to a given route */
  [key: string]: UserPermissionAccess
}

export enum UserPermissionAccess {
  /** No access to the route */
  NO_ACCESS = 'No Access',

  /** Read only access to the route */
  READ_ONLY = 'Read Only',

  /** Read and write access to the route */
  READ_WRITE = 'Read/Write',
}
